export type ShareByURLAction = 'share' | 'copy';

/**
 * Visual style of the share modal.
 * - `default`: social buttons row + a copy-link input field.
 * - `card`: larger title with social + copy-link icon tiles (incl. Messenger).
 */
export type ShareModalVariant = 'default' | 'card';

export interface ShareInformation {
  url: string;
  title?: string;
  text?: string;
  modalTitle?: string;
  /**
   * Resolved URL of a preview image shown at the top of the `card` modal
   * variant (e.g. the artwork being shared).
   */
  imageUrl?: string;
  /**
   * Resolved URL of a (tiling) background image rendered behind the preview
   * image in the `card` modal variant.
   */
  imageBackgroundUrl?: string;
}

export const REFERRER_QUERY_PARAM = 'frm';
